import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MoneyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M22.595 4.6c-.49-.49-1.14-.76-1.83-.76H3.245c-.69 0-1.34.27-1.83.76s-.76 1.14-.76 1.83v11.14c0 .69.27 1.34.76 1.83s1.14.76 1.83.76h17.51c.69 0 1.34-.27 1.83-.76s.76-1.14.76-1.83V6.43c0-.69-.27-1.34-.76-1.83h.01zm-1.24 12.98c0 .16-.06.31-.17.42a.59.59 0 01-.42.17H3.245a.59.59 0 01-.42-.17.59.59 0 01-.17-.42V6.43c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h17.51c.16 0 .31.06.42.17.11.11.17.26.17.42v11.14l.01.01z"
                        }),
                        _jsx("path", {
                            d: "M5.275 10.61c-.37 0-.72.15-.99.41s-.41.62-.41.99.15.73.41.99.61.41.99.41c.37 0 .73-.15.99-.41s.41-.62.41-.99-.15-.72-.41-.99c-.26-.26-.62-.41-.99-.41zm13.46 0c-.37 0-.72.14-.99.41-.26.26-.41.61-.41.99s.14.72.41.99c.26.26.61.4.98.4s.73-.15.99-.41.41-.62.41-.99-.15-.73-.41-.99-.62-.41-.99-.41l.01.01zm-5.79.45l-1.56-.34s-.08-.04-.11-.07a.152.152 0 01-.03-.13c0-.05.03-.09.06-.12s.08-.05.12-.05h1.03c.07 0 .13.02.19.06.06.04.1.09.12.16.18.52.76.79 1.28.61.52-.18.79-.76.61-1.28-.16-.46-.46-.85-.85-1.12a2.31 2.31 0 00-.79-.34v-.41c0-.55-.45-1-1-1s-1 .45-1 1v.37c-.39.08-.75.25-1.04.52a2.183 2.183 0 00-.31 2.9c.31.44.77.74 1.3.86l1.56.34c.08.02.15.06.2.13.05.07.07.15.06.23 0 .08-.05.15-.11.21-.06.05-.14.08-.21.08h-.89a.33.33 0 01-.31-.22 1.003 1.003 0 00-1.89.67c.16.46.46.85.85 1.12.24.17.51.27.79.34v.41c0 .55.45 1 1 1s1-.45 1-1v-.4c.37-.09.71-.26 1-.52.43-.39.7-.91.75-1.48.06-.57-.09-1.14-.42-1.61-.33-.46-.83-.79-1.39-.92h-.01z"
                        })
                    ]
                })
            })
        ]
    });
};
MoneyIcon.isCarinaIcon = true;
export default MoneyIcon;
